import React, { Component } from 'react';

import { Label, Headline, Disclaimer, Button } from '../../theme';
import { Dishwasher } from '../../svg';
import { isMobile } from '../../util';

class DishwasherSolution extends Component {
  render() {
    return (
      <div id="VaseSol" className="container__fluid page__solution">
        {
          !isMobile && (
            <div className="start hands">
              <Dishwasher.Hands />
            </div>
          )
        }
        <div className="w__flex w__flex-column Justify-center Justify-start__mobile">
          <Label
            marginLeft={isMobile ? false : '20vw'}
            background="#840050"
          >
            solutia mamei
          </Label>
          {
            isMobile
              ? <Headline small  >
                <p style={{ color: '#d33c64' }}>ECONOMISESTI 6L DE APA CU </p>
                <p style={{ color: '#d33c64' }}>DOAR 1 kWh? IA </p>
                <p style={{ color: '#d33c64' }}>O MASINA DE SPALAT VASE</p>
                <p style={{ color: '#d33c64' }}>NOUA IAR CONSUMUL DE ENERGIE</p>
                <p style={{ color: '#d33c64' }}>va scadea cu 33%.</p>
              </Headline>
              : <Headline padding="20vw" small alignLeft >
                <p style={{ color: '#d33c64' }}>O MASINA NOUA DE SPALAT VASE TE AJUTA</p>
                <p style={{ color: '#d33c64' }}>SA ECONOMISESTI PANA LA 6L DE APA RECE.</p>
                <p style={{ color: '#d33c64' }}>CU UN CONSUM DE NUMAI 1kWh DE </p>
                <p style={{ color: '#d33c64' }}>ENERGIE ELECTRICA, SCAZI 33% DIN </p>
                <p style={{ color: '#d33c64' }}>FACTURA LA ENERGIE.</p>
              </Headline>
          }
          <div className="w__flex Align-right w__flex-column__mobile Align-left__mobile">
            <Disclaimer
              style={{
                paddingLeft: isMobile ? '0' : '20vw'
              }}
            >
              <span>
                Comparativ cu cele din clasa energetica A, <strong>masinile de spalat vase
                <br className="mobile__hidden" />
                din clasa A+ consuma cu 15% mai putina energie electrica.</strong>
            </span>
            </Disclaimer>
            <span>
              <Button arctic to="https://www.arctic.ro/masini-de-spalat-vase.html">
                <span className="mobile__hidden">Vezi</span>  produsele arctic
              </Button>
              {
                isMobile && (
                  <Button enel >
                    <span className="mobile__hidden">Vezi</span>  oferta enel
                  </Button>
                )
              }
            </span>
          </div>
        </div>
        <div className="end dancer">
          <Dishwasher.Dancer />
        </div>
        {
          !isMobile && (
            <Button enel >
              <span className="mobile__hidden">Vezi</span>  oferta enel
            </Button>
          )
        }
      </div>
    );
  }
}

export default DishwasherSolution;


// WEBPACK FOOTER //
// ./src/components/pages/Vase/DishwasherSolution.jsx